/* =====================================================
   Easychoice Product Recommendation Quiz
   assets/ec-quiz.js
   ===================================================== */

(function () {
  'use strict';

  /* -------------------------------------------------- */
  /* TRACKING                                            */
  /* -------------------------------------------------- */
  function track(event, params) {
    params = params || {};
    try {
      if (window.dataLayer) window.dataLayer.push({ event: event, quiz: params });
      if (window.fbq) window.fbq('trackCustom', event, params);
    } catch (e) {}
  }

  function getUrlParams() {
    var params = {};
    try {
      window.location.search.slice(1).split('&').forEach(function (pair) {
        var parts = pair.split('=');
        if (parts[0]) params[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1] || '');
      });
    } catch (e) {}
    return params;
  }

  /* -------------------------------------------------- */
  /* QUESTIONS                                           */
  /* -------------------------------------------------- */
  const QUESTIONS = [
    {
      slug: 'goals',
      type: 'multi',
      max: 3,
      prompt: 'Hva er dine viktigste helsemål?',
      sub: 'Velg opptil 3',
      options: [
        { value: 'heart',    label: 'Hjerte og sirkulasjon',      icon: '❤️' },
        { value: 'brain',    label: 'Hjerne og konsentrasjon',    icon: '🧠' },
        { value: 'joints',   label: 'Ledd og bevegelse',          icon: '🦴' },
        { value: 'energy',   label: 'Energi og vitalitet',        icon: '⚡' },
        { value: 'skin_hair',label: 'Hud, hår og negler',         icon: '✨' },
        { value: 'aging',    label: 'Aldring og lang levetid',    icon: '🌱' },
        { value: 'immunity', label: 'Immunforsvar',               icon: '🛡️' },
        { value: 'recovery', label: 'Restitusjon etter trening',  icon: '💪' },
        { value: 'sleep',    label: 'Søvn og stressmestring',     icon: '😴' },
        { value: 'gut',      label: 'Tarm og fordøyelse',         icon: '🌿' },
      ],
    },
    {
      slug: 'fish_intake',
      type: 'single',
      prompt: 'Hvor ofte spiser du fet fisk?',
      sub: 'Laks, makrell, sild og lignende',
      options: [
        { value: 'daily',      label: 'Daglig eller nesten daglig' },
        { value: 'twice_week', label: '2–3 ganger i uken' },
        { value: 'once_week',  label: 'Én gang i uken' },
        { value: 'rarely',     label: 'Sjelden (1–3 ganger i måneden)' },
        { value: 'never',      label: 'Aldri eller nesten aldri' },
      ],
    },
    {
      slug: 'diet',
      type: 'single',
      prompt: 'Hvilken kosttype passer best for deg?',
      sub: '',
      options: [
        { value: 'omnivore',    label: 'Altetende – spiser alt' },
        { value: 'pescatarian', label: 'Pescetarianer – spiser fisk, ikke kjøtt' },
        { value: 'vegetarian',  label: 'Vegetarianer' },
        { value: 'vegan',       label: 'Veganer' },
        { value: 'keto',        label: 'Ketogen / lavkarbo' },
      ],
    },
    {
      slug: 'activity',
      type: 'single',
      prompt: 'Hva er aktivitetsnivået ditt?',
      sub: '',
      options: [
        { value: 'sedentary', label: 'Stillesittende – lite bevegelse til daglig' },
        { value: 'light',     label: 'Lett aktiv – gåturer, lett trening 1–2 x/uke' },
        { value: 'moderate',  label: 'Moderat aktiv – trening 3–4 x/uke' },
        { value: 'high',      label: 'Høyt aktiv – trening 5+ x/uke' },
        { value: 'athlete',   label: 'Konkurranseidrettsutøver' },
      ],
    },
    {
      slug: 'age',
      type: 'single',
      prompt: 'Hvilken aldersgruppe tilhører du?',
      sub: '',
      options: [
        { value: 'under_25', label: 'Under 25 år' },
        { value: '25_34',    label: '25–34 år' },
        { value: '35_44',    label: '35–44 år' },
        { value: '45_54',    label: '45–54 år' },
        { value: '55_64',    label: '55–64 år' },
        { value: 'over_65',  label: '65 år eller eldre' },
      ],
    },
    {
      slug: 'pregnancy',
      type: 'single',
      prompt: 'Er du gravid eller ammer for øyeblikket?',
      sub: '',
      options: [
        { value: 'no',            label: 'Nei' },
        { value: 'pregnant',      label: 'Ja, jeg er gravid' },
        { value: 'breastfeeding', label: 'Ja, jeg ammer' },
        { value: 'planning',      label: 'Vi planlegger graviditet' },
      ],
    },
    {
      slug: 'medications',
      type: 'single',
      prompt: 'Bruker du blodfortynnende medisiner?',
      sub: 'F.eks. Warfarin, Xarelto eller Eliquis',
      options: [
        { value: 'no',             label: 'Nei' },
        { value: 'yes_blood_thin', label: 'Ja, blodfortynnende' },
        { value: 'yes_other',      label: 'Ja, andre reseptbelagte medisiner' },
      ],
    },
    {
      slug: 'focus',
      type: 'multi',
      max: 3,
      prompt: 'Er det noen spesifikke områder du vil fokusere på?',
      sub: 'Velg opptil 3',
      options: [
        { value: 'inflammation',   label: 'Betennelsesdempende',          icon: '🔥' },
        { value: 'bone_density',   label: 'Beintetthet og skjeletthelse', icon: '🦷' },
        { value: 'muscle_mass',    label: 'Muskelmasse og styrke',        icon: '🏋️' },
        { value: 'mental_clarity', label: 'Mental skarphet og hukommelse',icon: '🧩' },
        { value: 'longevity_ext',  label: 'Lang levetid og cellefornyelse',icon: '🔬' },
        { value: 'skin_glow',      label: 'Glød og hudelastisitet',       icon: '🌟' },
        { value: 'endurance',      label: 'Utholdenhet og oksygenopptak', icon: '🏃' },
        { value: 'hydration',      label: 'Hydrering og elektrolyttbalanse',icon: '💧' },
        { value: 'stress_cortisol',label: 'Stress og kortisolregulering', icon: '🧘' },
      ],
    },
    {
      slug: 'allergies',
      type: 'multi',
      max: 6,
      prompt: 'Har du noen allergier eller intoleranser?',
      sub: 'Velg alt som passer, eller "Ingen"',
      options: [
        { value: 'none',         label: 'Ingen – alt er greit' },
        { value: 'fish_allergy', label: 'Fiskeallergi' },
        { value: 'shellfish',    label: 'Skalldyrallergi' },
        { value: 'gluten',       label: 'Glutenintolerans / cøliaki' },
        { value: 'dairy',        label: 'Laktoseintolerans / melkeallergi' },
        { value: 'soy',          label: 'Soyaallergi' },
      ],
    },
    {
      slug: 'format',
      type: 'single',
      prompt: 'Foretrekker du kapsler eller flytende?',
      sub: '',
      options: [
        { value: 'capsules',      label: 'Kapsler – enkel dosering, smaker ingenting' },
        { value: 'liquid',        label: 'Flytende – raskere opptak, enkelt å blande' },
        { value: 'no_preference', label: 'Ingen preferanse' },
      ],
    },
  ];

  /* -------------------------------------------------- */
  /* SCORE DELTAS                                        */
  /* -------------------------------------------------- */
  const SCORE_DELTAS = {
    goals: {
      heart:    { omega3_need: 3, vitamin_d_need: 1 },
      brain:    { omega3_need: 2, longevity_need: 1 },
      joints:   { omega3_need: 2, magnesium_need: 1, collagen_need: 2 },
      energy:   { energy_need: 3, magnesium_need: 2, electrolyte_need: 1 },
      skin_hair:{ collagen_need: 3, skin_hair_need: 3, omega3_need: 1 },
      aging:    { longevity_need: 4, collagen_need: 2, omega3_need: 1 },
      immunity: { omega3_need: 2, vitamin_d_need: 3 },
      recovery: { recovery_need: 3, magnesium_need: 2, electrolyte_need: 2, collagen_need: 1 },
      sleep:    { magnesium_need: 3, energy_need: 1 },
      gut:      { magnesium_need: 1, energy_need: 1 },
    },
    fish_intake: {
      daily:      { omega3_need: -2 },
      twice_week: { omega3_need: 0 },
      once_week:  { omega3_need: 2 },
      rarely:     { omega3_need: 4 },
      never:      { omega3_need: 5 },
    },
    diet: {
      omnivore:    {},
      pescatarian: { omega3_need: -1 },
      vegetarian:  { omega3_need: 2, vitamin_d_need: 1 },
      vegan:       { omega3_need: 3, vitamin_d_need: 2, energy_need: 1 },
      keto:        { electrolyte_need: 2, magnesium_need: 2, omega3_need: 1 },
    },
    activity: {
      sedentary: { energy_need: 1, omega3_need: 1 },
      light:     {},
      moderate:  { recovery_need: 2, magnesium_need: 1, electrolyte_need: 1 },
      high:      { recovery_need: 3, magnesium_need: 2, electrolyte_need: 2, collagen_need: 1 },
      athlete:   { recovery_need: 4, magnesium_need: 3, electrolyte_need: 3, collagen_need: 2, energy_need: 2 },
    },
    age: {
      under_25: { collagen_need: -1 },
      '25_34':  {},
      '35_44':  { collagen_need: 1, omega3_need: 1 },
      '45_54':  { collagen_need: 2, vitamin_d_need: 1, longevity_need: 1, omega3_need: 2 },
      '55_64':  { collagen_need: 3, vitamin_d_need: 2, longevity_need: 2, omega3_need: 2 },
      over_65:  { collagen_need: 3, vitamin_d_need: 2, longevity_need: 3, omega3_need: 3, magnesium_need: 1 },
    },
    pregnancy: {
      no:            {},
      pregnant:      { omega3_need: 3, vitamin_d_need: 2, magnesium_need: 2 },
      breastfeeding: { omega3_need: 2, vitamin_d_need: 2, energy_need: 1 },
      planning:      { omega3_need: 1, vitamin_d_need: 1 },
    },
    medications: { no: {}, yes_blood_thin: {}, yes_other: {} },
    focus: {
      inflammation:    { omega3_need: 2, recovery_need: 1 },
      bone_density:    { vitamin_d_need: 2, magnesium_need: 1, collagen_need: 1 },
      muscle_mass:     { recovery_need: 2, collagen_need: 1, magnesium_need: 1 },
      mental_clarity:  { omega3_need: 2, longevity_need: 1 },
      longevity_ext:   { longevity_need: 4, omega3_need: 1 },
      skin_glow:       { collagen_need: 3, skin_hair_need: 2 },
      endurance:       { electrolyte_need: 2, recovery_need: 1, omega3_need: 1 },
      hydration:       { electrolyte_need: 3, magnesium_need: 1 },
      stress_cortisol: { magnesium_need: 3, energy_need: 1 },
    },
    allergies: {
      none:         {},
      fish_allergy: { omega3_need: -10 },
      shellfish:    {},
      gluten:       {},
      dairy:        {},
      soy:          {},
    },
    routine_scope: {},
    format:        {},
  };

  /* -------------------------------------------------- */
  /* PRODUCT CATALOG                                     */
  /* -------------------------------------------------- */
  const CDN = 'https://cdn.shopify.com/s/files/1/0618/6028/2434/files/';

  const PRODUCTS = {
    omega3_liquid_60: {
      slug: 'omega3_liquid_60',
      name: 'Omega-3 Original Flytende 60%',
      tagline: 'EPA/DHA med Vitamin D3 og E',
      format: 'liquid',
      nutrients: { epa_dha: true, vit_d3: true, vit_e: true },
      primary_needs: ['omega3_need'],
      threshold: { omega3_need: 4 },
      variantId: 42137724715074,
      price: 34900,
      subPrice: 19544,   // 44% abonnementsrabatt (intro)
      url: '/products/easy-choice-60-omega-3-original-flytende',
      image: CDN + 'ec-email-o3-flytende.jpg?v=1786038603',
      badges: ['Mest populær'],
    },
    omega3_capsule_80: {
      slug: 'omega3_capsule_80',
      name: 'Omega-3 Premium 80% Kapsler',
      tagline: 'Høykonsentrert EPA/DHA med Vitamin D3',
      format: 'capsules',
      nutrients: { epa_dha: true, vit_d3: true },
      primary_needs: ['omega3_need'],
      threshold: { omega3_need: 4 },
      variantId: 42137756860482,
      price: 44900,
      subPrice: 25144,   // 44% abonnementsrabatt (intro)
      url: '/products/omega-3-kapsler-premium-1000mg',
      image: CDN + 'ec-email-o3-premium.jpg?v=1786038604',
      badges: [],
    },
    omega3_k2_capsule: {
      slug: 'omega3_k2_capsule',
      name: 'Omega-3 Premium 80% med K2+D3',
      tagline: 'EPA/DHA, Vitamin D3 og K2 – komplett pakke',
      format: 'capsules',
      nutrients: { epa_dha: true, vit_d3: true, vit_k2: true },
      primary_needs: ['omega3_need', 'vitamin_d_need'],
      threshold: { omega3_need: 4 },
      variantId: 42137714982978,
      price: 57900,
      subPrice: 32424,   // 44% abonnementsrabatt (intro)
      url: '/products/easy-choice-80-omega-3-premium-kapsler-med-vitamin-k2',
      image: CDN + 'NyOmega-3Premium80_K2Miljo.jpg?v=1780776057',
      badges: ['Anbefalt over 45'],
      contraindication_medications: ['yes_blood_thin'],
    },
    omega3_k2_liquid: {
      slug: 'omega3_k2_liquid',
      name: 'Omega-3 Flytende med K2+D3+E',
      tagline: 'Høykonsentrert flytende med vitaminer',
      format: 'liquid',
      nutrients: { epa_dha: true, vit_d3: true, vit_k2: true, vit_e: true },
      primary_needs: ['omega3_need', 'vitamin_d_need'],
      threshold: { omega3_need: 4 },
      variantId: 42137722421314,
      price: 46900,
      subPrice: 26264,   // 44% abonnementsrabatt (intro)
      url: '/products/omega-3-flytende',
      image: CDN + 'O-3_flytende_vitaminer.jpg?v=1770921553',
      badges: [],
      contraindication_medications: ['yes_blood_thin'],
    },
    omega3_astaxanthin: {
      slug: 'omega3_astaxanthin',
      name: 'Omega-3 + Astaxantin',
      tagline: 'EPA/DHA med kraftig antioksidant',
      format: 'capsules',
      nutrients: { epa_dha: true, vit_d3: true, vit_k2: true, astaxanthin: true },
      primary_needs: ['omega3_need', 'longevity_need', 'skin_hair_need'],
      threshold: { omega3_need: 3, longevity_need: 3 },
      variantId: 42987025662018,
      price: 67900,
      subPrice: 45493,   // 33% abonnementsrabatt
      url: '/products/omega-3-kapsler-astaxantin',
      image: CDN + 'Omega-3Atxproduktbilde.png?v=1770921553',
      badges: ['Longevity'],
      contraindication_medications: ['yes_blood_thin'],
    },
    magnesium: {
      slug: 'magnesium',
      name: 'Magnesium Premium 120 kaps',
      tagline: 'Søvn, muskler og stressmestring',
      format: 'capsules',
      nutrients: { magnesium: true },
      primary_needs: ['magnesium_need'],
      threshold: { magnesium_need: 3 },
      variantId: 43654286770242,
      price: 44900,
      subPrice: 30083,   // 33% abonnementsrabatt
      daysSupply: 40,    // 120 kaps / 3 per dag
      url: '/products/magnesium-120kap',
      image: CDN + 'Magnesium_120_kaps_miljobilde_low.jpg?v=1776710018',
      badges: [],
    },
    collagen: {
      slug: 'collagen',
      name: 'Kollagen',
      tagline: 'Hud, hår, negler og leddstøtte',
      format: 'capsules',
      nutrients: { collagen: true },
      primary_needs: ['collagen_need', 'skin_hair_need'],
      threshold: { collagen_need: 4, skin_hair_need: 3 },
      variantId: 42137743818818,
      price: 44900,
      subPrice: 25144,   // 44% abonnementsrabatt (intro)
      url: '/products/collagen',
      image: CDN + 'Kollagen_ba6f4df4-9dd2-4149-a31e-7c7fc57185dc.jpg?v=1770921553',
      badges: [],
    },
    spermidine: {
      slug: 'spermidine',
      name: 'Spermidine',
      tagline: 'Cellefornyelse og lang levetid',
      format: 'capsules',
      nutrients: { spermidine: true },
      primary_needs: ['longevity_need'],
      threshold: { longevity_need: 5 },
      variantId: 42798232764482,
      price: 89900,
      subPrice: 71920,   // 20% abonnementsrabatt
      daysSupply: 45,    // 90 kaps / 2 per dag
      url: '/products/spermidine',
      image: CDN + 'Spermidine_Produktbilde_1.jpg?v=1775668087',
      badges: ['Longevity'],
      contraindication_pregnancy: ['pregnant', 'breastfeeding'],
    },
    electrolytes: {
      slug: 'electrolytes',
      name: 'Elektrolytter',
      tagline: 'Hydrering og restitusjon etter trening',
      format: 'powder',
      nutrients: { electrolytes: true, magnesium: true },
      primary_needs: ['electrolyte_need'],
      threshold: { electrolyte_need: 4 },
      variantId: 42148587798594,
      price: 39900,
      subPrice: null,    // Ingen abonnementsordning
      daysSupply: 30,    // 30 poser / 1 per dag
      url: '/products/salte-elektrolytter-velg-smak',
      image: CDN + '5.webp?v=1761391935',
      badges: ['Trening'],
    },
  };

  /* -------------------------------------------------- */
  /* PACKAGES                                            */
  /* -------------------------------------------------- */
  const PACKAGES = {
    basis: {
      name: 'Basis Helsepakke',
      handle: 'basis-helsepakke-abonnement',
      tagline: 'Omega-3 + Magnesium – grunnlaget for god helse',
      includes: ['omega3_liquid_60', 'omega3_capsule_80', 'omega3_k2_liquid', 'omega3_k2_capsule'],
      also_includes: ['magnesium'],
      variantId: 43780314890306,
      regularPrice: 89800,
      subPrice: 60166,   // 33% rabatt (fra Shopify selling plan)
      match_threshold: { omega3_need: 4, magnesium_need: 3 },
    },
    longevity: {
      name: 'Premium Longevity',
      handle: 'premium-longevity-abonnement',
      tagline: 'Spermidine + Omega-3 + Magnesium – for deg som tenker langsiktig',
      includes: ['omega3_liquid_60', 'omega3_capsule_80', 'omega3_k2_liquid', 'omega3_k2_capsule'],
      also_includes: ['magnesium', 'spermidine'],
      variantId: 43780314988610,
      regularPrice: 179700,
      subPrice: 120399,  // 33% rabatt (fra Shopify selling plan)
      match_threshold: { omega3_need: 4, magnesium_need: 3, longevity_need: 5 },
      contraindication_pregnancy: ['pregnant', 'breastfeeding'],
    },
  };

  /* -------------------------------------------------- */
  /* LEIV QUOTES (contextual)                            */
  /* -------------------------------------------------- */
  const LEIV_QUOTES = {
    omega3_focus:
      'Omega-3 er grunnlaget i enhver god helserutine. Basert på dine svar har jeg satt sammen det jeg mener er optimalt for deg.',
    longevity_focus:
      'For deg som tenker langsiktig er cellefornyelse og antioksidanter helt avgjørende. Her er min anbefaling.',
    skin_focus:
      'Hud, hår og negler gjenspeiler hva kroppen får innenfra. La oss starte med det som gir raskest synlig effekt.',
    energy_focus:
      'Energi handler om mer enn kosthold – riktig tilskudd kan gjøre en stor forskjell i hverdagen.',
    recovery_focus:
      'God restitusjon er nøkkelen til fremgang. Her er det jeg ville startet med.',
    default:
      'Basert på svarene dine har jeg satt sammen en anbefaling som passer akkurat deg og dine mål.',
  };

  const LEIV_PHOTO =
    'https://cdn.shopify.com/s/files/1/0618/6028/2434/files/ec-leiv-bilde2.jpg?v=1786042906';

  /* -------------------------------------------------- */
  /* SCORING FUNCTIONS                                   */
  /* -------------------------------------------------- */
  function freshScores() {
    return {
      omega3_need:    0,
      vitamin_d_need: 0,
      magnesium_need: 0,
      collagen_need:  0,
      longevity_need: 0,
      energy_need:    0,
      recovery_need:  0,
      skin_hair_need: 0,
      electrolyte_need: 0,
    };
  }

  function applyDeltas(scores, slug, value) {
    const table = SCORE_DELTAS[slug];
    if (!table) return;
    const vals = Array.isArray(value) ? value : [value];
    vals.forEach(function (v) {
      const delta = table[v];
      if (!delta) return;
      Object.keys(delta).forEach(function (need) {
        scores[need] = Math.min(10, Math.max(0, (scores[need] || 0) + delta[need]));
      });
    });
  }

  function recalcScores(answers) {
    var scores = freshScores();
    QUESTIONS.forEach(function (q) {
      if (answers[q.slug] !== undefined) {
        applyDeltas(scores, q.slug, answers[q.slug]);
      }
    });
    return scores;
  }

  /* -------------------------------------------------- */
  /* RECOMMENDATION ENGINE                               */
  /* -------------------------------------------------- */
  function resolveOmega3(scores, answers) {
    if (scores.omega3_need < 4) return null;

    var format = answers.format || 'no_preference';
    var meds = answers.medications || 'no';
    var bloodThin = meds === 'yes_blood_thin';
    var age = answers.age || '';
    var focus = answers.focus || [];

    var needsK2 =
      focus.includes('bone_density') ||
      ['45_54', '55_64', 'over_65'].includes(age) ||
      scores.vitamin_d_need >= 4;

    var highLongevity = scores.longevity_need >= 5;

    if (needsK2 && !bloodThin) {
      if (format === 'liquid') return PRODUCTS.omega3_k2_liquid;
      if (highLongevity) return PRODUCTS.omega3_astaxanthin;
      return PRODUCTS.omega3_k2_capsule;
    }

    if (format === 'liquid') return PRODUCTS.omega3_liquid_60;
    return PRODUCTS.omega3_capsule_80;
  }

  function getNonOmegaCandidates(scores, answers) {
    var candidates = [];
    ['magnesium', 'collagen', 'spermidine', 'electrolytes'].forEach(function (slug) {
      var p = PRODUCTS[slug];
      var meetsThreshold = Object.keys(p.threshold).every(function (need) {
        return scores[need] >= p.threshold[need];
      });
      if (!meetsThreshold) return;

      // Safety exclusions
      var preg = answers.pregnancy || 'no';
      if (p.contraindication_pregnancy && p.contraindication_pregnancy.includes(preg)) return;

      candidates.push(p);
    });
    return candidates;
  }

  function applyScope(candidates, scopeAnswer, scores) {
    // Auto: number of needs >= 5 (excluding omega3 which is handled separately)
    var highNeeds = ['magnesium_need','collagen_need','longevity_need','energy_need',
      'recovery_need','skin_hair_need','electrolyte_need']
      .filter(function (n) { return scores[n] >= 5; }).length;
    var cap = Math.min(Math.max(highNeeds, 1), 3);

    // Sort by combined primary need score
    candidates.sort(function (a, b) {
      var sa = a.primary_needs.reduce(function (s, n) { return s + (scores[n] || 0); }, 0);
      var sb = b.primary_needs.reduce(function (s, n) { return s + (scores[n] || 0); }, 0);
      return sb - sa;
    });

    return candidates.slice(0, cap);
  }

  function findMatchingPackage(omega3, nonOmega, scores, answers) {
    var preg = answers.pregnancy || 'no';
    var hasMag = nonOmega.some(function (p) { return p.slug === 'magnesium'; });
    var hasSper = nonOmega.some(function (p) { return p.slug === 'spermidine'; });
    var hasOmega = !!omega3;

    // Longevity package
    if (hasOmega && hasMag && hasSper && !PACKAGES.longevity.contraindication_pregnancy?.includes(preg)) {
      var lt = PACKAGES.longevity.match_threshold;
      if (Object.keys(lt).every(function (n) { return scores[n] >= lt[n]; })) {
        return PACKAGES.longevity;
      }
    }

    // Basis package
    if (hasOmega && hasMag) {
      var bt = PACKAGES.basis.match_threshold;
      if (Object.keys(bt).every(function (n) { return scores[n] >= bt[n]; })) {
        return PACKAGES.basis;
      }
    }

    return null;
  }

  function pickLeivQuote(scores) {
    if (scores.longevity_need >= 5) return LEIV_QUOTES.longevity_focus;
    if (scores.skin_hair_need >= 4) return LEIV_QUOTES.skin_focus;
    if (scores.energy_need >= 4)    return LEIV_QUOTES.energy_focus;
    if (scores.recovery_need >= 4)  return LEIV_QUOTES.recovery_focus;
    if (scores.omega3_need >= 5)    return LEIV_QUOTES.omega3_focus;
    return LEIV_QUOTES.default;
  }

  /* -------------------------------------------------- */
  /* QUIZ STATE MACHINE                                  */
  /* -------------------------------------------------- */
  function QuizMachine(rootEl) {
    this.root = rootEl;
    this.state = 'intro';
    this.currentQ = 0;
    this.answers = {};
    this.scores = freshScores();
    this.recommendations = [];
    this.selected = new Set();
    this.subscription = false;
    this.suggestedPackage = null;
    this.leivQuote = LEIV_QUOTES.default;
    this.renderer = new QuizRenderer(rootEl, this);
    this.urlParams = getUrlParams();
    this.refParam = this.urlParams.ref || '';

    var self = this;
    var _handleVisibility = function () {
      if (document.visibilityState === 'hidden' &&
          self.state === 'questions' && self.currentQ > 0) {
        track('quiz_abandon', { last_question: self.currentQ, ref: self.refParam });
      }
    };
    document.addEventListener('visibilitychange', _handleVisibility);

    this._bindEvents();
    this.renderer.show('intro');
    track('quiz_view', { ref: this.refParam });
  }

  QuizMachine.prototype.transition = function (action, payload) {
    var self = this;
    payload = payload || {};

    if (action === 'START') {
      this.state = 'questions';
      this.currentQ = 0;
      this.renderer.show('questions');
      this.renderer.renderQuestion();
      track('quiz_start', { ref: this.refParam });
      return;
    }

    if (action === 'ANSWER') {
      this.answers[payload.slug] = payload.value;
      track('quiz_question_' + (this.currentQ + 1), { slug: payload.slug, answer: payload.value, ref: this.refParam });
      this.scores = recalcScores(this.answers);

      if (this.currentQ < QUESTIONS.length - 1) {
        this.currentQ++;
        this.renderer.renderQuestion();
      } else {
        this.transition('CALCULATE');
      }
      return;
    }

    if (action === 'NEXT_MULTI') {
      var q = QUESTIONS[this.currentQ];
      var val = this.answers[q.slug];
      if (!val || val.length === 0) return;
      this.scores = recalcScores(this.answers);
      if (this.currentQ < QUESTIONS.length - 1) {
        this.currentQ++;
        this.renderer.renderQuestion();
      } else {
        this.transition('CALCULATE');
      }
      return;
    }

    if (action === 'BACK') {
      if (this.state === 'questions' && this.currentQ > 0) {
        this.currentQ--;
        this.renderer.renderQuestion();
      } else if (this.state === 'questions' && this.currentQ === 0) {
        this.state = 'intro';
        this.renderer.show('intro');
      }
      return;
    }

    if (action === 'CALCULATE') {
      this.state = 'calculating';
      this.renderer.show('calculating');
      this.renderer.animateCalculating();
      var self = this;
      setTimeout(function () { self._calculate(); }, 2200);
      return;
    }

    if (action === 'SHOW_RESULTS') {
      this.state = 'results';
      this.renderer.show('results');
      this.renderer.renderResults();
      return;
    }

    if (action === 'TOGGLE_PRODUCT') {
      if (!this.selected.has(payload.slug)) {
        track('quiz_product_deselected', { product: payload.slug, ref: this.refParam });
      }
      if (this.selected.has(payload.slug)) {
        this.selected.delete(payload.slug);
      } else {
        this.selected.add(payload.slug);
      }
      this.renderer.updateProductCards();
      this.renderer.updatePriceSummary();
      this.renderer.updateWarnings();
      return;
    }

    if (action === 'TOGGLE_SUBSCRIPTION') {
      this.subscription = !this.subscription;
      track('quiz_subscription_toggled', { state: this.subscription ? 'on' : 'off', ref: this.refParam });
      this.renderer.updatePriceSummary();
      return;
    }

    if (action === 'ADD_PACKAGE_TO_CART') {
      this._addPackageToCart();
      return;
    }

    if (action === 'ADD_TO_CART') {
      this._addToCart();
      return;
    }

    if (action === 'SEND_EMAIL') {
      this._sendEmail(payload.email, payload.newsletter);
      return;
    }

    if (action === 'VIEW_CART') {
      window.location.href = '/cart';
      return;
    }

    if (action === 'RETAKE') {
      this._reset();
      return;
    }

    if (action === 'BACK_TO_RESULTS') {
      this.state = 'results';
      this.renderer.show('results');
      return;
    }
  };

  QuizMachine.prototype._calculate = function () {
    var omega3 = resolveOmega3(this.scores, this.answers);
    var nonOmega = getNonOmegaCandidates(this.scores, this.answers);
    var scope = this.answers.routine_scope || 'auto_scope';
    var trimmed = applyScope(nonOmega, scope, this.scores);

    this.recommendations = [omega3].concat(trimmed).filter(Boolean);
    this.selected = new Set(this.recommendations.map(function (p) { return p.slug; }));
    this.suggestedPackage = findMatchingPackage(omega3, trimmed, this.scores, this.answers);
    this.leivQuote = pickLeivQuote(this.scores);

    var recSlugs = this.recommendations.map(function (p) { return p.slug; });
    track('quiz_complete', {
      segment: this.leivQuote === LEIV_QUOTES.longevity_focus ? 'longevity' :
                this.leivQuote === LEIV_QUOTES.skin_focus ? 'skin' :
                this.leivQuote === LEIV_QUOTES.energy_focus ? 'energy' :
                this.leivQuote === LEIV_QUOTES.recovery_focus ? 'recovery' : 'omega3',
      recommended_products: recSlugs,
      has_package: !!this.suggestedPackage,
      ref: this.refParam,
    });

    var allToLoad = this.recommendations.slice();
    if (this.suggestedPackage) allToLoad.push(this.suggestedPackage);
    var self = this;
    this._loadSellingPlans(allToLoad, function () {
      self.transition('SHOW_RESULTS');
    });
  };

  QuizMachine.prototype._addToCart = function () {
    var self = this;

    var items = Array.from(this.selected).map(function (slug) {
      var p = PRODUCTS[slug];
      if (!p) return null;
      var item = { id: p.variantId, quantity: 1, properties: { '_anbefalt av': 'Dr. Leiv' } };
      if (self.subscription && p.selling_plan_id) {
        item.selling_plan = p.selling_plan_id;
      }
      return item;
    }).filter(Boolean);

    if (!items.length) return;

    var btn = self.root.querySelector('[data-action="ADD_TO_CART"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Legger til...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status === 422 || data.status === 400) {
          throw new Error(data.description || data.message || 'Kunne ikke legge til');
        }
        var cartVal = 0;
        Array.from(self.selected).forEach(function (s) { cartVal += (PRODUCTS[s] ? PRODUCTS[s].price : 0); });
        if (self.subscription) cartVal = Math.round(cartVal * 0.67);
        track('quiz_add_to_cart', {
          value: cartVal / 100,
          is_subscription: self.subscription,
          is_bundle: false,
          ref: self.refParam,
          currency: 'NOK',
        });
        if (typeof window.refreshCart === 'function') window.refreshCart();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        self.state = 'cart-added';
        self.renderer.show('cart-added');
      })
      .catch(function (err) {
        console.error('Quiz cart error:', err);
        if (btn) { btn.disabled = false; btn.textContent = 'Legg i handlekurv'; }
        alert('Noe gikk galt – prøv igjen eller kontakt oss.');
      });
  };

  QuizMachine.prototype._addPackageToCart = function () {
    var self = this;
    var pkg = this.suggestedPackage;
    if (!pkg) return;

    var item = { id: pkg.variantId, quantity: 1 };
    if (pkg.selling_plan_id) item.selling_plan = pkg.selling_plan_id;

    var btn = self.root.querySelector('[data-action="ADD_PACKAGE_TO_CART"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Legger til...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status === 422 || data.status === 400) {
          throw new Error(data.description || data.message || 'Kunne ikke legge til');
        }
        track('quiz_add_to_cart', {
          value: (pkg.sub_price || pkg.subPrice) / 100,
          is_subscription: !!pkg.selling_plan_id,
          is_bundle: true,
          ref: self.refParam,
          currency: 'NOK',
        });
        if (typeof window.refreshCart === 'function') window.refreshCart();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        self.state = 'cart-added';
        self.renderer.show('cart-added');
      })
      .catch(function (err) {
        console.error('Package cart error:', err);
        if (btn) { btn.disabled = false; btn.textContent = 'Bestill pakkeabonnement'; }
        alert('Noe gikk galt – prøv igjen eller kontakt oss.');
      });
  };

  QuizMachine.prototype._sendEmail = function (email, newsletter) {
    if (!email || !email.includes('@')) return;
    var self = this;

    if (newsletter) {
      // Try Klaviyo first (if installed)
      if (window._learnq) {
        try {
          window._learnq.push(['identify', { '$email': email, '$consent': ['email'] }]);
        } catch (e) {}
      } else {
        // Fallback: Shopify contact form
        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'form_type=customer&utf8=%E2%9C%93&contact%5Bemail%5D=' +
                encodeURIComponent(email) + '&contact%5Btags%5D=newsletter,quiz-signup',
        }).catch(function () {});
      }
      track('quiz_email_submitted', { newsletter: true, ref: this.refParam });
    }

    var names = this.recommendations.map(function (p) { return '- ' + p.name; }).join('\n');
    var subject = encodeURIComponent('Din Easychoice-anbefaling fra Dr. Leiv');
    var body = encodeURIComponent(
      'Hei!\n\nHer er din personlige anbefaling:\n\n' + names +
      '\n\nBestill her: https://easychoice.no/pages/helsequiz\n\nHa en fin dag!'
    );
    window.open('mailto:' + email + '?subject=' + subject + '&body=' + body, '_blank');
    self.renderer.show('email-sent');
  };

  QuizMachine.prototype._loadSellingPlans = function (items, callback) {
    var count = items.length;
    if (!count) { callback(); return; }
    var done = 0;
    var finish = function () { done++; if (done >= count) callback(); };

    items.forEach(function (item) {
      // For products: use item.url; for packages: use item.handle
      var handle = item.handle || (item.url || '').split('/products/')[1];
      if (!handle) { finish(); return; }
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var v = (data.variants || []).find(function (vv) { return vv.id === item.variantId; });
          if (v && v.selling_plan_allocations && v.selling_plan_allocations.length) {
            var alloc = v.selling_plan_allocations[0];
            item.selling_plan_id = alloc.selling_plan_id;
            // Store actual subscription price for exact savings display
            if (alloc.price !== undefined) item.sub_price = parseInt(alloc.price);
            if (alloc.compare_at_price !== undefined) item.regular_price = parseInt(alloc.compare_at_price);
          }
          finish();
        })
        .catch(function () { finish(); });
    });
  };

  QuizMachine.prototype.totalPrice = function () {
    var total = 0;
    var self = this;
    this.selected.forEach(function (slug) {
      var p = PRODUCTS[slug];
      if (!p) return;
      if (self.subscription) {
        // Use fetched sub_price first, then static subPrice, then 0.67 fallback
        total += (p.sub_price || p.subPrice || Math.round(p.price * 0.67));
      } else {
        total += p.price;
      }
    });
    return total;
  };

  QuizMachine.prototype._reset = function () {
    this.state = 'intro';
    this.currentQ = 0;
    this.answers = {};
    this.scores = freshScores();
    this.recommendations = [];
    this.selected = new Set();
    this.subscription = false;
    this.suggestedPackage = null;
    this.renderer.show('intro');
  };

  QuizMachine.prototype._bindEvents = function () {
    var self = this;

    this.root.addEventListener('click', function (e) {
      // Action buttons
      var actionEl = e.target.closest('[data-action]');
      if (actionEl) {
        var action = actionEl.dataset.action;
        var payload = {};

        if (action === 'SEND_EMAIL') {
          var input = self.root.querySelector('.ec-email-input');
          var newsCheck = self.root.querySelector('#ec-newsletter-toggle');
          payload.email = input ? input.value.trim() : '';
          payload.newsletter = newsCheck ? newsCheck.checked : false;
        }
        self.transition(action, payload);
        return;
      }

      // Option buttons
      var optBtn = e.target.closest('.ec-option__btn');
      if (optBtn) {
        self._handleOptionClick(optBtn);
        return;
      }

      // Product card toggle
      var card = e.target.closest('.ec-product-card');
      if (card && card.dataset.slug) {
        self.transition('TOGGLE_PRODUCT', { slug: card.dataset.slug });
        return;
      }
    });

    // Email: Enter key
    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.classList.contains('ec-email-input')) {
        self.transition('SEND_EMAIL', { email: e.target.value.trim() });
      }
    });

    // Subscription toggle (checkbox)
    this.root.addEventListener('change', function (e) {
      if (e.target.id === 'ec-sub-toggle') {
        self.transition('TOGGLE_SUBSCRIPTION');
      }
    });
  };

  QuizMachine.prototype._handleOptionClick = function (btn) {
    var li = btn.closest('.ec-option');
    var optionsList = btn.closest('.ec-options');
    var q = QUESTIONS[this.currentQ];

    if (q.type === 'single') {
      // Deselect all, select this
      optionsList.querySelectorAll('.ec-option').forEach(function (el) {
        el.classList.remove('is-selected');
      });
      li.classList.add('is-selected');

      var value = li.dataset.value;
      var self = this;
      // Auto-advance after brief visual confirmation
      setTimeout(function () {
        self.transition('ANSWER', { slug: q.slug, value: value });
      }, 280);

    } else {
      // Multi-select
      var value = li.dataset.value;

      // If "none" is clicked, clear all others
      if (value === 'none') {
        optionsList.querySelectorAll('.ec-option').forEach(function (el) {
          el.classList.remove('is-selected');
        });
        li.classList.add('is-selected');
        this.answers[q.slug] = ['none'];
        this._updateMultiNext(optionsList, q);
        return;
      }

      // If something other than "none" is clicked, deselect "none"
      optionsList.querySelectorAll('.ec-option').forEach(function (el) {
        if (el.dataset.value === 'none') el.classList.remove('is-selected');
      });

      var wasSelected = li.classList.contains('is-selected');
      if (wasSelected) {
        li.classList.remove('is-selected');
      } else {
        // Check max
        var currentSelected = optionsList.querySelectorAll('.ec-option.is-selected').length;
        if (currentSelected >= (q.max || 3)) {
          // Flash the max limit visually
          optionsList.classList.add('ec-options--max-reached');
          var self = this;
          setTimeout(function () { optionsList.classList.remove('ec-options--max-reached'); }, 600);
          return;
        }
        li.classList.add('is-selected');
      }

      var selected = Array.from(optionsList.querySelectorAll('.ec-option.is-selected'))
        .map(function (el) { return el.dataset.value; });
      this.answers[q.slug] = selected;
      this._updateMultiNext(optionsList, q);
    }
  };

  QuizMachine.prototype._updateMultiNext = function (optionsList, q) {
    var panel = this.root.querySelector('[data-panel="questions"]');
    var nextBtn = panel ? panel.querySelector('[data-action="NEXT_MULTI"]') : null;
    if (!nextBtn) return;
    var val = this.answers[q.slug];
    nextBtn.disabled = !val || val.length === 0;
  };

  /* -------------------------------------------------- */
  /* QUIZ RENDERER                                       */
  /* -------------------------------------------------- */
  function QuizRenderer(rootEl, machine) {
    this.root = rootEl;
    this.machine = machine;
    this.panels = {};

    var self = this;
    ['intro', 'questions', 'calculating', 'results', 'email-sent', 'cart-added'].forEach(function (name) {
      self.panels[name] = rootEl.querySelector('[data-panel="' + name + '"]');
    });
  }

  QuizRenderer.prototype.show = function (panelName) {
    var self = this;
    Object.keys(this.panels).forEach(function (name) {
      var el = self.panels[name];
      if (!el) return;
      el.classList.remove('is-active');
    });
    var target = this.panels[panelName];
    if (target) target.classList.add('is-active');
  };

  QuizRenderer.prototype.renderQuestion = function () {
    var m = this.machine;
    var q = QUESTIONS[m.currentQ];
    var panel = this.panels['questions'];
    if (!panel) return;

    // Progress
    var pct = (m.currentQ / QUESTIONS.length) * 100;
    var fill = panel.querySelector('.ec-progress__fill');
    var label = panel.querySelector('.ec-progress__label');
    if (fill) fill.style.width = pct + '%';
    if (label) label.textContent = 'Spørsmål ' + (m.currentQ + 1) + ' av ' + QUESTIONS.length;

    // Prompt
    var prompt = panel.querySelector('.ec-question__prompt');
    var sub = panel.querySelector('.ec-question__sub');
    if (prompt) prompt.textContent = q.prompt;
    if (sub) sub.textContent = q.sub || '';

    // Build options
    var list = panel.querySelector('.ec-options');
    if (!list) return;
    list.innerHTML = '';
    list.className = 'ec-options' + (q.options.length <= 4 ? '' : '');

    var savedVal = m.answers[q.slug];
    var savedArr = savedVal ? (Array.isArray(savedVal) ? savedVal : [savedVal]) : [];

    q.options.forEach(function (opt) {
      var li = document.createElement('li');
      li.className = 'ec-option' + (savedArr.includes(opt.value) ? ' is-selected' : '');
      li.dataset.value = opt.value;

      li.innerHTML =
        '<button class="ec-option__btn" type="button">' +
          (opt.icon ? '<span class="ec-option__icon">' + opt.icon + '</span>' : '') +
          '<span class="ec-option__label">' + opt.label + '</span>' +
          '<span class="ec-option__check" aria-hidden="true">' +
            '<svg width="12" height="9" viewBox="0 0 12 9" fill="none">' +
              '<path d="M1 4L4.5 7.5L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</span>' +
        '</button>';

      list.appendChild(li);
    });

    // Nav buttons
    var nav = panel.querySelector('.ec-question-nav');
    if (nav) {
      nav.innerHTML = '';

      var backBtn = document.createElement('button');
      backBtn.className = 'ec-btn ec-btn--ghost';
      backBtn.type = 'button';
      backBtn.dataset.action = 'BACK';
      backBtn.textContent = '← Tilbake';
      nav.appendChild(backBtn);

      if (q.type === 'multi') {
        var nextBtn = document.createElement('button');
        nextBtn.className = 'ec-btn ec-btn--primary';
        nextBtn.type = 'button';
        nextBtn.dataset.action = 'NEXT_MULTI';
        nextBtn.textContent = m.currentQ < QUESTIONS.length - 1 ? 'Neste →' : 'Se anbefaling';
        nextBtn.disabled = !savedArr.length;
        nav.appendChild(nextBtn);
      }
    }
  };

  QuizRenderer.prototype.animateCalculating = function () {
    var msgs = [
      'Analyserer helsemål...',
      'Sjekker næringsstoffbehov...',
      'Beregner optimal kombinasjon...',
      'Kvalitetssikrer anbefalingen...',
    ];
    var el = this.root.querySelector('.ec-calculating__msg');
    if (!el) return;
    var i = 0;
    var interval = setInterval(function () {
      if (i >= msgs.length) { clearInterval(interval); return; }
      el.style.opacity = '0';
      setTimeout(function () {
        el.textContent = msgs[i];
        el.style.opacity = '1';
        i++;
      }, 200);
    }, 500);
  };

  QuizRenderer.prototype.renderResults = function () {
    var m = this.machine;
    var panel = this.panels['results'];
    if (!panel) return;

    // Dr. Leiv quote
    var quoteEl = panel.querySelector('.ec-results__doctor-quote');
    if (quoteEl) quoteEl.textContent = '"' + m.leivQuote + '"';

    // No recommendations case
    if (!m.recommendations.length) {
      var productsEl = panel.querySelector('.ec-results__products');
      if (productsEl) {
        productsEl.innerHTML =
          '<div class="ec-no-rec">' +
          '<div class="ec-no-rec__icon">🔬</div>' +
          '<p class="ec-no-rec__title">Vi kan ikke gi en anbefaling</p>' +
          '<p class="ec-no-rec__body">Basert på dine opplysninger kan vi dessverre ikke gi en trygg anbefaling. ' +
          'Vi anbefaler at du kontakter oss direkte for personlig rådgivning.</p>' +
          '<a href="/pages/kontakt" class="ec-btn ec-btn--primary">Kontakt oss</a>' +
          '</div>';
      }
      return;
    }

    this.renderPackageSuggestion();
    this.renderProducts();
    this.updateWarnings();
    this.updatePriceSummary();
  };

  QuizRenderer.prototype.renderProducts = function () {
    var m = this.machine;
    var container = this.root.querySelector('.ec-results__products');
    if (!container) return;
    container.innerHTML = '';

    var sectionHeader = document.createElement('div');
    sectionHeader.className = 'ec-products__header';
    sectionHeader.textContent = m.suggestedPackage
      ? 'Eller kjøp enkeltvis:'
      : 'Din anbefalte rutine:';
    container.appendChild(sectionHeader);

    m.recommendations.forEach(function (p) {
      var isSelected = m.selected.has(p.slug);
      var card = document.createElement('div');
      card.className = 'ec-product-card ' + (isSelected ? 'is-selected' : 'is-deselected');
      card.dataset.slug = p.slug;

      var badgesHtml = (p.badges || []).map(function (b) {
        return '<span class="ec-badge ec-badge--teal">' + b + '</span>';
      }).join('');

      // Price per day calculation (only for products with confirmed daysSupply)
      var pricePerDayHtml = '';
      if (p.daysSupply) {
        var priceForDay = m.subscription && p.subPrice
          ? p.sub_price || p.subPrice
          : p.price;
        var perDay = Math.round(priceForDay / p.daysSupply);
        pricePerDayHtml = '<div class="ec-product-card__per-day">kr ' + perDay + ',- per dag</div>';
      }

      card.innerHTML =
        '<img class="ec-product-card__img" src="' + p.image + '" alt="' + p.name + '" loading="lazy">' +
        '<div class="ec-product-card__body">' +
          (badgesHtml ? '<div class="ec-product-card__badges">' + badgesHtml + '</div>' : '') +
          '<div class="ec-product-card__name">' + p.name + '</div>' +
          '<div class="ec-product-card__tagline">' + p.tagline + '</div>' +
          '<div class="ec-product-card__price">' + formatPrice(m.subscription && p.subPrice ? (p.sub_price || p.subPrice) : p.price) + pricePerDayHtml + '</div>' +
        '</div>' +
        '<div class="ec-product-card__check">' +
          '<svg class="ec-product-card__check-icon" width="12" height="9" viewBox="0 0 12 9" fill="none">' +
            '<path d="M1 4L4.5 7.5L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</div>';

      container.appendChild(card);
    });
  };

  QuizRenderer.prototype.renderPackageSuggestion = function () {
    var m = this.machine;
    var banner = this.root.querySelector('.ec-package-banner');
    if (!banner) return;

    if (!m.suggestedPackage) {
      banner.classList.remove('is-visible');
      return;
    }

    var pkg = m.suggestedPackage;
    var savings = pkg.regularPrice - pkg.subPrice;
    var pkgHandle = pkg === PACKAGES.basis
      ? 'basis-helsepakke-abonnement'
      : 'premium-longevity-abonnement';

    // Build "inkluderer" list: actual recommended omega3 + also_includes
    var omega3Slug = Array.from(m.selected).find(function (s) {
      return pkg.includes.indexOf(s) !== -1;
    });
    var includedNames = [];
    if (omega3Slug && PRODUCTS[omega3Slug]) includedNames.push(PRODUCTS[omega3Slug].name);
    (pkg.also_includes || []).forEach(function (s) {
      if (PRODUCTS[s]) includedNames.push(PRODUCTS[s].name);
    });
    var includedHtml = includedNames.map(function (n) {
      return '<span class="ec-package-item">&#10003; ' + n + '</span>';
    }).join('');

    banner.classList.add('is-visible');
    banner.innerHTML =
      '<div class="ec-package-banner__label">Pakkeabonnement – Best verdi</div>' +
      '<div class="ec-package-banner__name">' + pkg.name + '</div>' +
      '<div class="ec-package-banner__includes">' + includedHtml + '</div>' +
      '<div class="ec-package-banner__pricing">' +
        '<span class="ec-package-banner__price">' + formatPrice(pkg.subPrice) + '/levering</span>' +
        '<span class="ec-package-banner__regular">' + formatPrice(pkg.regularPrice) + '</span>' +
        '<span class="ec-badge ec-badge--star">Spar ' + formatPrice(savings) + '</span>' +
      '</div>' +
      '<div class="ec-package-banner__perks">Gratis frakt &nbsp;&middot;&nbsp; Ingen bindingstid &nbsp;&middot;&nbsp; Pause eller avslutt når som helst</div>' +
      '<div style="margin-top:14px;display:flex;gap:10px;align-items:center;flex-wrap:wrap;">' +
        '<button type="button" class="ec-btn ec-btn--primary" style="font-size:14px;padding:10px 22px;" data-action="ADD_PACKAGE_TO_CART">' +
          'Legg pakken i handlekurv &#8594;' +
        '</button>' +
        '<a href="/products/' + pkgHandle + '" style="font-family:var(--ec-font-body);font-size:13px;color:var(--ec-gray-600);text-decoration:underline;">Se produktsiden</a>' +
      '</div>';
  };

  QuizRenderer.prototype.updateProductCards = function () {
    var m = this.machine;
    var cards = this.root.querySelectorAll('.ec-product-card');
    cards.forEach(function (card) {
      var slug = card.dataset.slug;
      if (m.selected.has(slug)) {
        card.classList.add('is-selected');
        card.classList.remove('is-deselected');
      } else {
        card.classList.remove('is-selected');
        card.classList.add('is-deselected');
      }
    });
  };

  QuizRenderer.prototype.updatePriceSummary = function () {
    var m = this.machine;
    var total = m.totalPrice();
    var totalEl = this.root.querySelector('.ec-summary__total');
    var labelEl = this.root.querySelector('.ec-summary__total-label');
    var subLabel = this.root.querySelector('.ec-summary__sub-label');
    var subSavings = this.root.querySelector('.ec-summary__sub-savings');
    var toggle = this.root.querySelector('#ec-sub-toggle');

    if (totalEl) totalEl.textContent = formatPrice(total);
    if (toggle) toggle.checked = m.subscription;

    if (m.subscription) {
      if (labelEl) labelEl.textContent = 'Per levering:';
      if (subLabel) subLabel.textContent = 'Abonnement aktivert · Ingen bindingstid';
      // Exact savings: regular price minus actual subPrice
      var regularTotal = 0;
      m.selected.forEach(function (slug) {
        var p = PRODUCTS[slug];
        if (p) regularTotal += (p.regular_price || p.price);
      });
      var exactSavings = regularTotal - total;
      if (subSavings) subSavings.textContent = 'Du sparer ' + formatPrice(exactSavings) + ' · Gratis frakt inkludert';
    } else {
      if (labelEl) labelEl.textContent = 'Totalpris:';
      if (subLabel) subLabel.textContent = 'Abonnement (spar opptil 44% + gratis frakt)';
      if (subSavings) subSavings.textContent = 'Abonner: gratis frakt og automatisk levering';
    }
  };

  QuizRenderer.prototype.updateWarnings = function () {
    var m = this.machine;
    var container = this.root.querySelector('.ec-warnings');
    if (!container) return;
    container.innerHTML = '';

    var warnings = [];

    if ((m.answers.medications || '') === 'yes_blood_thin') {
      warnings.push({
        cls: 'danger',
        text: 'Du bruker blodfortynnende medisiner. Produkter med K2-vitamin er ekskludert. Konsulter alltid lege før oppstart av nye tilskudd.',
      });
    }

    if (['pregnant', 'breastfeeding'].includes(m.answers.pregnancy || '')) {
      warnings.push({
        cls: 'caution',
        text: 'Du er gravid eller ammer. Noen produkter er ekskludert av sikkerhetshensyn. Vi anbefaler alltid å konsultere lege.',
      });
    }

    var hasMag = m.selected.has('magnesium');
    var hasElec = m.selected.has('electrolytes');
    if (hasMag && hasElec) {
      warnings.push({
        cls: 'info',
        text: 'Merk: Elektrolytter inneholder noe magnesium. Magnesium Premium gir mer konsentrert dose. Du kan trygt bruke begge, men følg dosering.',
      });
    }

    if ((m.answers.medications || '') === 'yes_other') {
      warnings.push({
        cls: 'info',
        text: 'Du bruker reseptbelagte medisiner. Vi anbefaler at du sjekker med lege eller apotek at disse tilskuddene passer for deg.',
      });
    }

    warnings.forEach(function (w) {
      var el = document.createElement('div');
      el.className = 'ec-warning ec-warning--' + w.cls;
      el.textContent = w.text;
      container.appendChild(el);
    });
  };

  /* -------------------------------------------------- */
  /* HELPERS                                             */
  /* -------------------------------------------------- */
  function formatPrice(oere) {
    return 'kr ' + Math.round(oere / 100) + ',-';
  }

  /* -------------------------------------------------- */
  /* INIT                                                */
  /* -------------------------------------------------- */
  function init() {
    var sections = document.querySelectorAll('.ec-quiz-section');
    sections.forEach(function (el) {
      new QuizMachine(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
